import { render, staticRenderFns } from "./updataPro.vue?vue&type=template&id=27659da9&scoped=true&"
import script from "./updataPro.vue?vue&type=script&lang=js&"
export * from "./updataPro.vue?vue&type=script&lang=js&"
import style0 from "./updataPro.vue?vue&type=style&index=0&id=27659da9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27659da9",
  null
  
)

export default component.exports